import { inject } from 'aurelia-dependency-injection';
import { customAttribute } from 'aurelia-templating';
import { closest } from '@material/dom/ponyfill';
import { IMdcRippleElement } from '@aurelia-mdc-web/ripple';

@customAttribute('no-list-action-dyn')
@inject(Element)
export class NoListActionCustomAttribute {
  constructor(private root: HTMLElement) { }

  attached() {
    const item = closest(this.root, '.mdc-list-item') as HTMLElement;
    if (item) {
      item.style.pointerEvents = 'none';
      item.setAttribute('no-list-action', '');
      (item as IMdcRippleElement).au['mdc-ripple'].viewModel.disabled = true;
    }
  }
}
